// Adobe Font info for reference

// font-family: mostra-nuova,sans-serif;
// font-weight: 400;
// font-style: normal;

// font-family: mostra-nuova,sans-serif;
// font-weight: 700;
// font-style: normal;

// font-family: mostra-nuova,sans-serif;
// font-weight: 300;
// font-style: normal;

// font-family: mostra-nuova,sans-serif;
// font-weight: 800;
// font-style: normal;

const black = '#000'
const tanDark = '#E9D8AB'
const tanMedium = '#F2E9CF'
const tanLight = '#F9F4E8'
const brown = '#20110E'
const border = '#CFB490'
const red = '#C12C48'

export const breakpoints = ['40em', '48em', '64em', '85em', '90em', '120em'] // 640px / 768px / 1024px / 1360px / 1440px / 1920px
export const fontSizes = [10, 12, 15, 18, 20, 24, 30, 38, 48, 64, 80, 96]
export const lineHeights = [1, 3, 1.6, 1.6, 1.2, 1.1, 1.2, 1.2]
export const fontWeights = [300, 400, 400, 300]
export const space = [0, 4, 8, 16, 32, 64, 128, 256, 512]

const theme = {
  colors: {
    black,
    tanDark,
    tanMedium,
    tanLight,
    brown,
    border,
    red,
  },
  breakpoints,
  fontSizes,
  lineHeights,
  fonts: {
    body:
      "'mostra-nuova', sans-serif",
    headings:
      "'mostra-nuova', sans-serif",
  },
  sizes: {
    maxWidth: {
      xsmall: '30em',
      small: '40em',
      medium: '64em',
      large: '85em',
      xlarge: '90em',
      xxlarge: '120em',
    },
  },
  fontWeights: {
    light: 300,
    regular: 400,
    bold: 700,
    heavy: 800,
  },
  space,
}

export const sizes = {
  xsmall: { min: 0, max: 574 },
  small: { min: 575, max: 764 },
  medium: { min: 765, max: 991 },
  large: { min: 992, max: 1180 },
  xlarge: { min: 1181, max: Infinity },
}

export const zIndices = {
  modal: 9000,
  navigation: 1000,
}

export default theme
